module.exports = __webpack_public_path__ + "img/turn_face_left.c8f625fd.svg";